import { useState, useCallback } from "react";
import type { ReactNode } from "react";
import { ServerErrorContext } from "./ServerErrorContext.context";

export function ServerErrorProvider({ children }: { children: ReactNode }) {
  const [serverError, setServerError] = useState<Error | null>(null);

  const clearServerError = useCallback(() => {
    setServerError(null);
  }, []);

  return (
    <ServerErrorContext.Provider value={{ serverError, setServerError, clearServerError }}>
      {children}
    </ServerErrorContext.Provider>
  );
}